import { render } from "./ActiveFilters.vue?vue&type=template&id=fdc37154&scoped=true"
import script from "./ActiveFilters.vue?vue&type=script&lang=js"
export * from "./ActiveFilters.vue?vue&type=script&lang=js"

import "./ActiveFilters.vue?vue&type=style&index=0&id=fdc37154&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdc37154"]])

export default __exports__